module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Electric/air-dryer-bd8e81b526731f8d2429cc9a628f2382.svg";